import { render } from "./earning-coaching.vue?vue&type=template&id=c8d536c8"
import script from "./earning-coaching.vue?vue&type=script&lang=js"
export * from "./earning-coaching.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__